/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_AccessInputs */

const en_privacy_section_7_access = /** @type {(inputs: Privacy_Section_7_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right of access`)
};

const lv_privacy_section_7_access = /** @type {(inputs: Privacy_Section_7_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piekļuves tiesības`)
};

/**
* | output |
* | --- |
* | "Right of access" |
*
* @param {Privacy_Section_7_AccessInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_access = /** @type {((inputs?: Privacy_Section_7_AccessInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_AccessInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_access(inputs)
	return en_privacy_section_7_access(inputs)
});